import { render, staticRenderFns } from "./OffersSingleSlider.vue?vue&type=template&id=64a4c914&scoped=true&"
import script from "./OffersSingleSlider.vue?vue&type=script&lang=js&"
export * from "./OffersSingleSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4c914",
  null
  
)

export default component.exports